import React from 'react';
import {
  Box,
  Container,
  Flex,
  Text,
  useBreakpointValue,
  Image,
} from '@chakra-ui/react';
// import LoginImage from './login/LoginImage';
import LoginImage from '../../media/images/LoginImage.svg';
import SplashScreenContent from './SplashScreenContent';
import RegistrationPage from '../register/RegistrationPage';

const SplashScreen = ({ contentProps }) => {
  const isDesktop = useBreakpointValue({ base: false, lg: true });
  const { companyData } = contentProps;
  const showRegistrationPage =
    contentProps?.currentView === 'register' && companyData?.signedUp;
  if (showRegistrationPage) {
    return <RegistrationPage companyData={companyData} />;
  }
  return (
    <Box minH="100vh" bg="gray.50">
      <Container maxW="container.xxl" px={4}>
        <Flex
          minH="100vh"
          align="center"
          justify="center"
          direction={{ base: 'column', lg: 'row' }}
        >
          {/* Left side - Login Image */}
          {isDesktop && (
            <Box
              flex="1"
              maxW="800px"
              h="100vh"
              position="relative"
              overflow="hidden"
            >
              <Image
                src={LoginImage}
                alt="Login Image"
                objectFit="cover"
                w="100%"
                h="100%"
              />
            </Box>
          )}

          {/* Right side - Login Form */}
          <Box
            flex="1"
            maxW={{ base: '100%', lg: '800px' }}
            w="full"
            bg="white"
            rounded="xl"
            boxShadow="xl"
            h="100vh"
            display="flex"
            alignItems="center"
          >
            <SplashScreenContent contentProps={contentProps} />
          </Box>
        </Flex>
      </Container>
    </Box>
  );
};

export default SplashScreen;
